import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

type GeologyCrushingTableFooterProps = {
  totalLoads?: number
  totalTonnes?: number
  isLoading: boolean
}

const GeologyCrushingTableFooter: React.FC<GeologyCrushingTableFooterProps> = ({
  totalLoads,
  totalTonnes,
  isLoading
}) => {
  return (
    <div className="flex justify-end md:items-center flex-col md:flex-row gap-2 bg-theme-surface-2 border border-theme-table-border border-t-2 border-t-theme-table-border p-2 mb-4 fade-up shadow">
      <div className="flex items-center justify-end">
        <span className="p-4 text-2xl text-theme-text translate-y-1 transition ease-out">Total Loads:</span>
        <span className="p-3 w-24 flex justify-center items-center font-bold bg-theme-warning rounded relative">
          <FontAwesomeIcon icon={faSpinner} spin
            className={`text-5xl text-theme-text transition ease-out opacity-${isLoading ? 100 : 0}`} />
          <span
            className={`text-4xl absolute top-1/2 transform -translate-y-[50%] transition ease-out opacity-${isLoading ? '0' : '100'}`}>
            {totalLoads}
          </span>
        </span>
      </div>
      <div className="flex items-center justify-end">
        <span className="p-4 text-2xl text-theme-text translate-y-1 transition ease-out">Total Tonnes:</span>
        <span className="p-3 flex min-w-36 justify-center items-center font-bold bg-theme-warning rounded relative">
          <FontAwesomeIcon icon={faSpinner} spin
            className={`text-5xl text-theme-text transition ease-out opacity-${isLoading ? 100 : 0}`} />
          <span
            className={`text-4xl  absolute top-1/2 transform -translate-y-[50%] transition ease-out opacity-${isLoading ? '0' : '100'}`}>
            {totalTonnes}
          </span>
        </span>
      </div>
    </div>
  )
}

export default GeologyCrushingTableFooter